import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MsalService } from '@azure/msal-angular';

@Component({
    selector: 'rax-app',
    templateUrl: './app.component.html',
    imports: [RouterOutlet],
})
export class AppComponent implements OnInit {
    private authService = inject(MsalService);

    ngOnInit(): void {
        this.authService.handleRedirectObservable().subscribe();
    }
}
